import React, { ChangeEvent, useState } from 'react';
// Types
import MediaFormats from 'types/MediaFormats';
// MUI
import { ButtonGroup } from '@material-ui/core';
// Layouts
import { Dialog, DialogTitle, DialogContent, DialogActions } from 'layouts/Dialog';
// Components
import { Button } from 'components/Buttons';
import { Input } from 'components/Controls';
import QRCode from 'components/QRCode';
import ImageUpload from 'components/ImageUpload';
import StyledMuiButton from 'components/StyledMuiButton';
// i18next
import { useTranslation } from 'react-i18next';
// Utilities
import { downloadQRCode } from 'utilities/utilities';

type Props = {
  open: boolean;
  onClose: () => void;
  quizName: string;
  quizNameSlug: string;
  qrCodeLogo: string;
}

const QRCodeGeneratorDialog:React.FC<Props> = ({
  // Props
  open, onClose, quizName, quizNameSlug, qrCodeLogo
}) => {
  const { t } = useTranslation();

  const [link, setLink] = useState<string>('');
  const onChangeLink = (e:ChangeEvent<HTMLInputElement>) => setLink(e.target.value);

  const [image, setImage] = useState<string>('');
  const onChangeImage = (imgUrl:string) => setImage(imgUrl);

  const [imageFormat, setImageFormat] = useState<MediaFormats.Logo | MediaFormats.RectLogo>(MediaFormats.Logo);

  return (
    <Dialog size="sm" open={open} onClose={onClose}>
      <DialogTitle title={t('dialogs.qrCodeGenerator.title')} onClose={onClose} />
      <DialogContent>
        <QRCode link={link} quizName={quizName} quizNameSlug={quizNameSlug} qrCodeLogo={image || qrCodeLogo} qrCodeLogoFormat={imageFormat} />
        <ButtonGroup size="small" style={{ marginBottom: '8px', marginTop: '16px' }}>
          <StyledMuiButton
            variant={imageFormat === MediaFormats.Logo ? 'contained' : 'outlined'}
            onClick={() => setImageFormat(MediaFormats.Logo)}
          >{t('labels.squareLogo')}</StyledMuiButton>
          <StyledMuiButton
            variant={imageFormat === MediaFormats.RectLogo ? 'contained' : 'outlined'}
            onClick={() => setImageFormat(MediaFormats.RectLogo)}
          >{t('labels.rectangularLogo')}</StyledMuiButton>
        </ButtonGroup>
        <ImageUpload
          key={imageFormat}
          value={image}
          onChange={onChangeImage}
          format={imageFormat}
          label={t('labels.qrCodeLogo')}
          className="sm:w-1/4"
        />
        <Input
          name="qr-code-link"
          className="mt-4"
          onChange={onChangeLink}
          value={link}
          label={t('labels.quizQRCodeLink')} id="publicLeaderboard.quizQRCodeLink"
          helperText={t('form.helperText.quizQRCodeLinkHint')}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
        >{t('buttons.close')}</Button>
        <Button
          variant="contained"
          onClick={() => downloadQRCode(quizName)}
        >{t('buttons.downloadQrCode')}</Button>
      </DialogActions>
    </Dialog>
  )
}

export default QRCodeGeneratorDialog;
